<template>
<!--  <div v-if="item?.file_path">-->
  <div v-if="showButton">
    <div v-if="isSmall" class="icon">
      <Button @click.prevent="getPdf"
              :disabled="isLoading"
              :loading="isLoading"
              v-tooltip.top="$t('downloadPdfTooltip')"
              class="p-button-text p-button-md p-p-1"
              icon="pi pi-file-pdf"
              :class="{'p-button-sm':buttonIsSmall, 'p-button-secondary':isSecondary}">
      </Button>
    </div>
    <div v-else-if="isBig">
      <Button @click.prevent="getPdf"
              :disabled="isLoading"
              :loading="isLoading"
              v-tooltip.top="$t('downloadPdfTooltip')"
              class="p-button-text p-button-lg p-button-secondary p-p-1"
              icon="pi pi-file-pdf"
              :class="{'p-button-sm':buttonIsSmall, 'p-button-secondary':isSecondary}">
      </Button>
    </div>

    <div v-else>
      <Button @click.prevent="getPdf"
              :disabled="isLoading"
              :loading="isLoading"
              class="p-button-text p-p-1"
              :class="{'p-button-sm':buttonIsSmall, 'p-button-secondary':isSecondary}"
              icon="pi pi-file-pdf"
              :label="$t('Download')"/>
    </div>
  </div>
</template>

<script>
import httpClient from "@/services/http.services";
import httpMixins from "@/mixins/httpMixins";
import settings from "@/settings";

export default {
  mixins: [ httpMixins ],
  name: 'DownloadPdfButton',
  props: {
    type: {
      type: String,
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    isBig: {
      type: Boolean,
      default: false,
    },
    buttonIsSmall: {
      type: Boolean,
      default: false,
    },
    isSecondary: {
      type: Boolean,
      default: false,
    },
    downloadEndpoint: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      settings
    }
  },
  methods: {
    async getPdf() {
      if (this.isLoading) return

      const documentId = this.item?.id
      if (!documentId) return false;
      this.isLoading = true
      try {

        const endpoints = {
          sales: 'sales-invoice/download-pdf',
          prepayment: 'prepayment-invoice/download-pdf',
          offer: 'offer/download-pdf',
          'work-order': 'order/download-work-order-pdf',
          billing: 'billing-invoice-system/download-pdf',
        }

        const endPoint = this.downloadEndpoint || endpoints[this.type]

        if (!endPoint) return

        const { status, data, headers } = await httpClient(
            `${endPoint}?id=${encodeURIComponent(documentId)}`,
            { responseType: 'arraybuffer' }
        );

        if (status !== 200 || !data) throw new Error('Empty response');

        const mime = headers['content-type'] || 'application/pdf';
        let filename = this.item.number || 'document.pdf';
        const cd = headers['content-disposition'];
        if (cd) {
          const m = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
          if (m) filename = decodeURIComponent(m[1] || m[2]);
        }

        // const blob = new Blob([data], { type: mime });
        // const objectUrl = URL.createObjectURL(blob);
        //
        // const win = window.open(objectUrl, '_blank');

        const blob = new Blob([data], { type: mime });
        const objectUrl = URL.createObjectURL(blob);

        if (this.settings.openAllLinksInSameTab) {
          window.location.assign(objectUrl);
          return;
        }

        const win = window.open(objectUrl, '_blank');

        if (!win || win.closed || typeof win.closed === 'undefined') {
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = filename;
          a.rel = 'noopener';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }

        setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
      } catch (err) {
        this.showFileNotFoundError();
      } finally {
        this.isLoading = false
      }
    },
  },
  computed: {
    showButton() {
      if (this.type === 'billing') {
        return !!this.item?.id
      }

      return !!this.item?.file_path
    },
  }
}
</script>

<style lang="scss" scoped>
.big-button {
  .icon {
    font-size: 1.6rem!important;
  }
}

.icon {
  font-size: 1.05rem;
}
</style>